"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const ui_theme_1 = __importDefault(require("@kyruus/ui-theme"));
const Delete_1 = __importDefault(require("@kyruus/react-ikons/Delete"));
const styles_1 = require("../../../styles");
function DeleteIcon({ enableRemove, onRemove, valueIndex, entityName }) {
    return enableRemove ? (react_1.default.createElement(styles_1.FieldFocusWrapper, null,
        react_1.default.createElement(styles_1.TextButton, { type: "button", onClick: () => onRemove(valueIndex), tabIndex: "0" },
            react_1.default.createElement(Delete_1.default, { color: ui_theme_1.default.color_link, size: ui_theme_1.default.font_size_heading_4, "aria-label": `Delete ${entityName}` })))) : null;
}
exports.default = DeleteIcon;
//# sourceMappingURL=delete-icon.js.map